import { courseCopy } from "../copy.js";
import { courseHasReadingAid } from "../reading-aids.js";
import Bar from "./bar.marko";
import Home from "./home.marko";
import Scene from "./scene.marko";
import Unit from "./unit.marko";
import People from "./people.marko";
import Person from "./person.marko";
import Words from "./words.marko";
import WordSet from "./set.marko";
import ScriptHome from "./script-home.marko";
import ScriptUnit from "./script-unit.marko";
import ScriptAudioTest from "./script-audio-test.marko";
import ScriptTapAudition from "./script-tap-audition.marko";
import ScriptReference from "./script-reference.marko";
import Switch from "./switch.marko";
import Paywall from "./paywall.marko";
import PracticeDialog from "../../quick-practice/views/dialog.marko";
import FreeTryScript from "../../quick-practice/views/free-try-script.marko";

static const VIEWS = { home: Home, scene: Scene, unit: Unit, people: People, person: Person, words: Words, set: WordSet, "script-home": ScriptHome, "script-unit": ScriptUnit, "script-audio-test": ScriptAudioTest, "script-reference": ScriptReference, "script-tap-audition": ScriptTapAudition };
static const CONTROLLERS = "course-profile course-audio course-table course-lookup course-progress course-lesson course-exercise course-gate course-script course-transliteration course-review-note quick-practice";

<const/data=input.data/>
<const/uiLang=data.uiLang || $global.uiLang || "en"/>
<const/uiCopy=data.copy || courseCopy(uiLang)/>
<const/sameLanguage=data.lang === uiLang/>
<if=data.view === "soon">
  <main class="ll-course ll-course-soon">
    <h1>${data.title}</h1>
    <p>${data.message}</p>
  </main>
</if>
<else>
  <main
    class=["ll-course", !sameLanguage && "show-en", courseHasReadingAid(data.lang) && !String(data.view || "").startsWith("script-") && "show-transliteration", `ll-course--${data.view}`]
    data-ll-component=CONTROLLERS
    data-ll-gender="f"
    data-ll-course-view=data.view
    data-ll-course-lang=data.lang
    data-ll-course-ui-lang=uiLang
  >
    <html-script>
      (function () {
        try {
          var root = document.querySelector("[data-ll-course-lang]");
          if (!root) return;
          var lang = root.getAttribute("data-ll-course-lang") || "";
          var ui = root.getAttribute("data-ll-course-ui-lang") || "";
          var saved = JSON.parse(localStorage.getItem("ll:course-settings") || "null");
          var chosen = saved && saved.showEnglishFor ? saved.showEnglishFor[lang + ":" + ui] : undefined;
          var show = lang !== ui && (typeof chosen !== "boolean" || chosen);
          root.classList.toggle("show-en", show);
        } catch (e) {}
      })();
    </html-script>
    <html-script data-ll-course-ui-copy type="application/json">$!{JSON.stringify(uiCopy).replace(/</g, "\\u003c")}</html-script>
    <div class="ll-course-root">
      <const/showTransliteration=courseHasReadingAid(data.lang) && data.view !== "scene" && !data.view.startsWith("script-") && data.unit?.type !== "words"/>
      <const/showEnglish=!sameLanguage && data.view === "person"/>
      <const/showBar=data.view !== "scene" && data.view !== "unit" && !data.view.startsWith("script-")/>
      <if=showTransliteration && !showBar>
        <div class="ll-course-reading-aid">
          <Switch label="Show transliteration" on=true attrs={ "data-ll-transliteration": "" }/>
        </div>
      </if>
      <if=showBar>
        <Bar tab=data.tab nav=data.nav copy=data.copy presets=data.presets showTransliteration=showTransliteration showEnglish=showEnglish englishOn=!sameLanguage/>
      </if>
      <${VIEWS[data.view]} ...data/>
    </div>
    <if=data.englishHint>
      <aside class="ll-course-en-hint" data-ll-en-hint data-ll-en-hint-key=(data.englishHint.storageKey || ("ll-course-en-hint:" + (data.lang || ""))) role="dialog" aria-labelledby="ll-course-en-hint-title">
        <button type="button" class="ll-course-en-hint__close" data-ll-en-hint-dismiss aria-label=data.englishHint.closeLabel>&times;</button>
        <p id="ll-course-en-hint-title">${data.englishHint.message}</p>
        <div class="ll-course-en-hint__actions">
          <a class="ll-course-en-hint__switch" href=data.englishHint.href>${data.englishHint.switchLabel}</a>
          <button type="button" class="ll-course-en-hint__later" data-ll-en-hint-dismiss>${data.englishHint.dismissLabel}</button>
        </div>
      </aside>
      <html-script>
        (function () {
          var hint = document.querySelector("[data-ll-en-hint]");
          if (!hint) return;
          var key = hint.getAttribute("data-ll-en-hint-key");
          try {
            if (localStorage.getItem(key) === "1") hint.hidden = true;
          } catch (e) {}
          hint.addEventListener("click", function (event) {
            if (!event.target.closest("[data-ll-en-hint-dismiss]")) return;
            hint.hidden = true;
            try { localStorage.setItem(key, "1"); } catch (e) {}
          });
        })();
      </html-script>
    </if>
    <div class="ll-course-pop" data-ll-pop role="tooltip" hidden>
      <strong data-ll-pop-word></strong>
      <span data-ll-pop-en></span>
      <small data-ll-pop-note></small>
    </div>
    <PracticeDialog decks=data.quickPractice/>
    <if=data.premiumGate && data.experience>
      <dialog class="ll-course-premium-dialog ll-premium-dialog ll-premium-design" data-ll-course-paywall aria-labelledby="ll-course-premium-title">
        <div class="ll-course-premium-scroll ll-premium-dialog__scroll"><Paywall copy=data.copy experience=data.experience gate=data.premiumGate/></div>
      </dialog>
      <html-script data-ll-course-pricing type="application/json">$!{JSON.stringify(data.premiumGate).replace(/</g, "\\u003c")}</html-script>
    </if>
    <html-script>
      (function () {
        var root = document.querySelector("[data-ll-course-lang]");
        if (!root) return;
        var on = root.classList.contains("show-en");
        var boxes = root.querySelectorAll("[data-ll-english]");
        for (var i = 0; i < boxes.length; i++) boxes[i].checked = on;
      })();
    </html-script>
  </main>
  <html-script>
    (function () {
      try {
        var root = document.querySelector("[data-ll-course-lang]");
        var note = root && root.querySelector("[data-ll-review-note]");
        if (!note) return;
        var saved = JSON.parse(localStorage.getItem("ll:course-review-dismissed") || "{}");
        if (saved[root.getAttribute("data-ll-course-lang")]) note.hidden = true;
      } catch (e) {}
    })();
  </html-script>
  <FreeTryScript/>
  <html-script src="/js/course-client.js" defer></html-script>
</else>
